import {
  SpaceBetween,
  Box,
  TextContent,
  ColumnLayout,
  FormField,
  Select,
  Input,
} from "@cloudscape-design/components-themed";
import { isEqual } from "lodash";
import {
  ConfirmationMerchantInfoItem,
  ConfirmResult,
} from "../../../features/api-interfaces";
import { CONFIRMATION_RESULT, LABELS } from "../constants";
import { getApiConfirmationResult, getConfirmationResultDict } from "../util";

interface ICorporateNumberMismatch {
  merchant: ConfirmationMerchantInfoItem;
  updateItem: (merchant: ConfirmationMerchantInfoItem) => void;
  isMerchantRegistered: boolean;
  confirmResultList: ConfirmResult[];
}

/**
 * 法人番号相違事由
 */
const CorporateNumberMismatch = (props: ICorporateNumberMismatch) => {
  const { merchant, updateItem, isMerchantRegistered, confirmResultList } =
    props;
  const isRegistered = confirmResultList.find((item) =>
    isEqual(item.individualHandlingReason, merchant.individualHandlingReason)
  )?.confirmationResult;

  return (
    <SpaceBetween direction={"vertical"} size={"s"}>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.CONFIRMATION_RESULT}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_LITTLE_LONG}>
              <Select
                selectedOption={getConfirmationResultDict(
                  merchant.confirmationResult
                )}
                options={CONFIRMATION_RESULT}
                filteringType={"none"}
                onChange={({ detail: { selectedOption } }) => {
                  updateItem({
                    ...merchant,
                    confirmationResult: getApiConfirmationResult(
                      selectedOption.value!
                    ),
                  });
                }}
                disabled={isMerchantRegistered || isRegistered}
              />
            </FormField>
          </ColumnLayout>
        </Box>
      </SpaceBetween>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.CORPORATE_NUMBER}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_LITTLE_LONG}>
              <Input value={String(merchant.corporateNumber ?? "")} readOnly />
            </FormField>
          </ColumnLayout>
        </Box>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.COMPANY_NAME_APPLICATION}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_SUPER_ADDRESS_LONG}>
              <Input
                value={String(merchant.companyNameApplication ?? "")}
                readOnly
              />
            </FormField>
          </ColumnLayout>
        </Box>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.COMPANY_NAME_NATIONAL_TAX_ADMIN_AGENCY}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_SUPER_ADDRESS_LONG}>
              <Input value={String(merchant.companyNameTax ?? "")} readOnly />
            </FormField>
          </ColumnLayout>
        </Box>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.COMPANY_NAME_KANA_APPLICATION}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_SUPER_ADDRESS_LONG}>
              <Input
                value={String(merchant.companyNameKanaApplication ?? "")}
                readOnly
              />
            </FormField>
          </ColumnLayout>
        </Box>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.COMPANY_NAME_KANA_NATIONAL_TAX_ADMIN_AGENCY}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_SUPER_ADDRESS_LONG}>
              <Input
                value={String(merchant.companyNameKanaTax ?? "")}
                readOnly
              />
            </FormField>
          </ColumnLayout>
        </Box>
      </SpaceBetween>
    </SpaceBetween>
  );
};

export default CorporateNumberMismatch;
